import { Capacitor } from '@capacitor/core'
import { RecapImagesModel } from '../models/RecapImagesModel'
import { RecapResponsesModel } from '../models/RecapReponsesModel'
import { RecapDefinitionsModel } from '../models/RecapDefinitionsModel'
import { boot } from 'quasar/wrappers'
import { bootErrorMessage } from './error/bootErrorMessage'
import { StoreRecapDefinitionsModel } from '../models/StoreRecapDefinitionsModel'
import { StoreRecapResponsesModel } from '../models/StoreRecapResponsesModel'
import { StoreRecapImagesModel } from '../models/StoreRecapImagesModel'

export default boot(async (/* { app, router, ... } */) => {
  try {
    /** Recaps */
    // Remove old recaps
    const { removeStaleRecapDefinitions } = RecapDefinitionsModel()
    await removeStaleRecapDefinitions().catch((error) => console.error(error))

    // Remove old responses
    const { removeStaleRecapResponses } = RecapResponsesModel()
    await removeStaleRecapResponses().catch((error) => console.error(error))

    if (Capacitor.isNativePlatform()) {
      // remove stale recap images
      const { removeStaleRecapImages } = RecapImagesModel()
      await removeStaleRecapImages().catch((error) => console.error(error))
    }

    /** Store Recaps */
    // Remove old recaps
    const { removeStaleStoreRecapDefinitions } = StoreRecapDefinitionsModel()
    await removeStaleStoreRecapDefinitions().catch((error) => console.error(error))

    // Remove old responses
    const { removeStaleStoreRecapResponses } = StoreRecapResponsesModel()
    await removeStaleStoreRecapResponses().catch((error) => console.error(error))

    if (Capacitor.isNativePlatform()) {
      // remove stale recap images
      const { removeStaleStoreRecapImages } = StoreRecapImagesModel()
      await removeStaleStoreRecapImages().catch((error) => console.error(error))
    }
  } catch (error) {
    bootErrorMessage(error, { stage: 'recaps' })
  }
})
